import { render, staticRenderFns } from "./navpath.vue?vue&type=template&id=c722dfd4&scoped=true&"
import script from "./navpath.vue?vue&type=script&lang=js&"
export * from "./navpath.vue?vue&type=script&lang=js&"
import style0 from "./navpath.vue?vue&type=style&index=0&id=c722dfd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c722dfd4",
  null
  
)

export default component.exports